import fetch from './fetch';
import { camelizeKeys, decamelizeKeys } from 'humps'

const logResponse = (response) => {
  if (process.env.NODE_ENV === 'development') {
    console.error(response);
  }
}

const decodeResponse = async (response) => {
  const text = await response.text();
  try {
    const json = JSON.parse(text);
    return typeof(json) === 'object' ? camelizeKeys(json) : json;
  } catch (error) {
    return text;
  }
}

const checkStatus = (response) => {
  if (response.status >= 200 && response.status < 300) {
    return response;
  } else {
    var error = new Error(response.status);
    return decodeResponse(response).then(parsedText => {
      error.response = parsedText;
      logResponse(parsedText);
      throw error;
    })
  }
};

export default class Api {
  constructor() {
    this.baseUrl = `${process.env.AMAZY_BASE_URL}/api`;
  };

  fetchApplication = (number) => {
    return this.request(
      'GET',
      `/applications/${number}`
    );
  };

  createApplication = () => {
    return this.request(
      'POST',
      '/applications'
    );
  };

  updateApplication = (application, form) => {
    return this.request(
      'PUT',
      `/applications/${application.number}`,
      decamelizeKeys({ form })
    );
  };

  submitXeroApplication = (form, organisation_id) => {
    return this.request(
      'POST',
      '/xero_applications',
      decamelizeKeys({ form, organisation_id })
    );
  };

  rewindApplication = (application) => {
    return this.request(
      'PUT',
      `/applications/${application.number}/rewind`
    );
  };

  fetchXeroOrganisation = () => {
    return this.request(
      'GET',
      `/xero/organisation`
    );
  }

  request = (method, suffixUrl, data) => {
    return fetch(
      `${this.baseUrl}${suffixUrl}`,
      {
        method,
        body: JSON.stringify(data),
        credentials: 'include',
        headers: {
          'Content-Type': 'application/json'
        }
      },
    )
      .then(checkStatus)
      .then(decodeResponse);
  };
}



// WEBPACK FOOTER //
// ./src/utils/api.js